import { makeStyles } from 'tss-react/mui';

import { isLightTheme } from 'uiKit/Theme/themeUtils';

const codeWrapperBackgroundDark = '#17191C';

const name = 'MultichainCodeExample';

export const useMultichainCodeExampleStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    backgroundImage: 'none',
    marginTop: theme.spacing(4),
  },
  header: {
    width: '50%',
    padding: theme.spacing(8),
    gap: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  copyButton: {
    boxShadow: 'none',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,

    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  btnDocs: {
    border: 'none',
    borderRadius: theme.shape.borderRadius,

    '&:hover': {
      color: isLightTheme(theme)
        ? theme.palette.background.paper
        : theme.palette.text.primary,
    },

    '&:active, &:focus': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  codeSampleWrapper: {
    margin: 0,
    background: isLightTheme(theme)
      ? theme.palette.text.primary
      : codeWrapperBackgroundDark,
    padding: theme.spacing(6),
    alignSelf: 'stretch',
    fontSize: 12,
    minHeight: '466px',
    lineBreak: 'anywhere',
  },
  sandboxHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tabsWrapper: {
    backgroundColor: isLightTheme(theme)
      ? theme.palette.background.default
      : theme.palette.secondary.dark,
    padding: theme.spacing(0.75),
    borderRadius: theme.shape.borderRadiusMd,
  },
  tab: {
    borderRadius: theme.shape.borderRadiusSm, // ex 9
    overflow: 'hidden',
  },
  codeSample: {
    whiteSpace: 'pre-wrap',
  },
}));
